import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import Const from 'constants';
import Tooltip from 'components/atoms/tooltip';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class SelectLineupResolver extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('GeneratorType', value));
    }

    render() {
        const {settings, sportConfig} = this.props;

        const options = {
            [Const.GENERATOR_TYPE_FRONTEND]: 'Browser',
            [Const.GENERATOR_TYPE_BACKEND_V1]: 'Server',
            // [Const.GENERATOR_TYPE_BACKEND_V2]: 'Server golp',
            // [Const.GENERATOR_TYPE_BACKEND_V3]: 'Server gohighs',
        };

        const generatorType = settings.getGeneratorType(sportConfig);

        return (
            <div className="input-info">
                <Tooltip subject="Use Server Side If You Find The Browser Side Optimization Is Running Slowly." />
                <SimpleSelect
                    key={generatorType}
                    value={generatorType}
                    options={options}
                    onChange={this.onChange.bind(this)}
                    testId="optimization-algorithm-dropdown"
                    optionTestIdAppend="algorithm-option"
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {lineupGenerator, sportConfig} = state;

    return {
        settings: lineupGenerator.settings,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(SelectLineupResolver);
